var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    filter: "url(#filter0_d_1285_634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_8_Resume"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.20703 50.1881V15.0319C6.20703 8.83597 11.2298 3.81311 17.4258 3.81311H52.5739C58.7698 3.81311 63.7927 8.83597 63.7927 15.0319V50.1881C63.7927 56.384 58.7698 61.4069 52.5739 61.4069H17.4258C11.2299 61.4069 6.20703 56.384 6.20703 50.1881Z",
    fill: "white",
    stroke: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M51.9863 20.7565H41.9199V19.86C41.9199 18.5065 40.8184 17.399 39.459 17.399H30.541C29.1875 17.399 28.0801 18.5065 28.0801 19.86V20.7565H18.0137C16.7188 20.7565 15.6641 21.8112 15.6641 23.1061V45.4655C15.6641 46.7662 16.7188 47.8209 18.0137 47.8209H51.9863C53.2812 47.8209 54.3359 46.7662 54.3359 45.4655V23.1061C54.3359 21.8112 53.2812 20.7565 51.9863 20.7565ZM53.1641 45.4655C53.1641 46.1158 52.6367 46.649 51.9863 46.649H18.0137C17.3633 46.649 16.8359 46.1158 16.8359 45.4655V23.1061C16.8359 22.4557 17.3633 21.9283 18.0137 21.9283H28.0801V22.2565C28.0801 23.6158 29.1875 24.7174 30.541 24.7174H39.459C40.8184 24.7174 41.9199 23.6158 41.9199 22.2565V21.9283H51.9863C52.6367 21.9283 53.1641 22.4557 53.1641 23.1061V45.4655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.625 33.5065C27.7867 33.5065 29.5391 31.7541 29.5391 29.5924C29.5391 27.4307 27.7867 25.6783 25.625 25.6783C23.4633 25.6783 21.7109 27.4307 21.7109 29.5924C21.7109 31.7541 23.4633 33.5065 25.625 33.5065Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.0098 40.3795V43.1803C31.0098 43.5084 30.7461 43.7662 30.4238 43.7662H20.832C20.5039 43.7662 20.2461 43.5084 20.2461 43.1803V40.3795C20.2461 37.4088 22.6602 34.9948 25.625 34.9948C28.5957 34.9948 31.0098 37.4088 31.0098 40.3795Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M38.5723 28.1763H43.8548C44.1788 28.1763 44.4408 27.9139 44.4408 27.5903C44.4408 27.2668 44.1788 27.0044 43.8548 27.0044H38.5723C38.2484 27.0044 37.9863 27.2668 37.9863 27.5903C37.9863 27.9139 38.2485 28.1763 38.5723 28.1763Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M38.5723 32.6404H48.3936C48.7175 32.6404 48.9796 32.378 48.9796 32.0544C48.9796 31.7309 48.7175 31.4685 48.3936 31.4685H38.5723C38.2484 31.4685 37.9863 31.7309 37.9863 32.0544C37.9863 32.378 38.2485 32.6404 38.5723 32.6404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M38.5723 37.1047H48.3936C48.7175 37.1047 48.9796 36.8424 48.9796 36.5188C48.9796 36.1952 48.7175 35.9329 48.3936 35.9329H38.5723C38.2484 35.9329 37.9863 36.1952 37.9863 36.5188C37.9863 36.8424 38.2485 37.1047 38.5723 37.1047Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M38.5723 41.5691H48.3936C48.7175 41.5691 48.9796 41.3067 48.9796 40.9832C48.9796 40.6596 48.7175 40.3972 48.3936 40.3972H38.5723C38.2484 40.3972 37.9863 40.6596 37.9863 40.9832C37.9863 41.3067 38.2485 41.5691 38.5723 41.5691Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1285_634",
    x: 0.0999999,
    y: -0.290015,
    width: 73.8,
    height: 73.7999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1285_634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1285_634",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCardIcon);
export default __webpack_public_path__ + "static/media/id-card-icon.fbdb77df5365da0d79193867c9e72c0f.svg";
export { ForwardRef as ReactComponent };